<template>
	<!-- 电话会销独立整页(/telesales): 只承载"我的会销"(老聊天库含电话私聊), 常规网页布局非弹窗;
	     池塘/我的电销/已成交不在本页(仍保留在聊天内嵌弹窗里) -->
	<div class="tsp-page">
		<div class="tsp-head">
			<div class="tsp-title">我的会销</div>
			<div class="tsp-bar">
				<el-radio-group v-model="phoneFilter" size="mini" @change="onPhoneFilter()">
					<el-radio-button label="all">全部</el-radio-button>
					<el-radio-button label="unread">未读</el-radio-button>
					<el-radio-button label="read">已读</el-radio-button>
					<el-radio-button label="fav">收藏</el-radio-button>
				</el-radio-group>
				<el-button size="mini" icon="el-icon-star-off" @click="msgFavOpen()">消息收藏夹</el-button>
				<el-button size="mini" icon="el-icon-s-custom" @click="adminDlg.visible = true">管理员号码</el-button>
				<el-button size="mini" icon="el-icon-refresh" :loading="phoneRefreshing" @click="onPhoneRefresh()">刷新老库数据</el-button>
			</div>
		</div>

		<div class="tsp-body" v-loading="loading">
			<!-- 按人聚合: 展开看该人的含电话私聊会话; 查看记录自动标已读 -->
			<el-table v-if="phoneFilter === 'all' || phoneFilter === 'unread'" :data="rows" size="small" max-height="calc(100vh - 230px)" :empty-text="phoneEmptyText" @expand-change="onPhoneExpand">
				<el-table-column type="expand">
					<template slot-scope="s">
						<div class="tsd-expand" v-loading="phoneExpandLoadingId === s.row.uid">
							<div v-if="phoneHistCache[s.row.uid] && !phoneHistCache[s.row.uid].length" class="tsd-nocall">没有含电话的私聊会话</div>
							<!-- 已读/未读分组展示: 未读tab只列未读; 其余tab未读在前已读在后, 不混排 -->
							<template v-for="g in convGroups(s.row.uid)">
								<div v-if="g.total" :key="g.k + 'h'" class="tsd-group-head">
									<span :class="g.k === 'unread' ? 'tsd-unread-badge' : 'tsd-read-badge'">{{ g.title }}({{ g.total }})</span>
								</div>
								<div v-for="c in g.list" :key="g.k + '-' + c.b" class="tsd-hist-line">
									<span class="tsd-hist-time">{{ fmtTime(c.lastTime) }}</span>
									<span class="tsd-hist-caller" :class="isAdminParty(c.b, c.bName) ? 'ts-admin' : ''">{{ c.bName || c.b }}</span>
									<el-tag v-if="isAdminParty(c.b, c.bName)" size="mini" type="danger">管理员</el-tag>
									<span v-if="c.region" class="tsd-hist-region">{{ c.region }}</span>
									<span class="tsd-hist-content">{{ c.cnt }}条含电话</span>
									<span v-if="c.remark" class="tsd-remark-text">备注: {{ c.remark }}</span>
									<el-button type="text" size="mini" @click="openPhoneMsgs(s.row, c)">查看记录</el-button>
									<el-button type="text" size="mini" @click="toggleRead(s.row, c)">{{ c.read ? '取消已读' : '标记已读' }}</el-button>
									<el-button type="text" size="mini" :class="c.fav ? 'tsd-fav-badge' : ''" @click="togglePhoneFav(s.row, c)">{{ c.fav ? '★已收藏' : '☆收藏' }}</el-button>
									<el-button type="text" size="mini" :class="isAdminParty(c.b, c.bName) ? 'ts-admin' : ''" @click="toggleAdminUser(c.b, c.bName)">{{ isAdminParty(c.b, c.bName) ? '取消管理员' : '标记管理员' }}</el-button>
									<el-button type="text" size="mini" @click="editPhoneRemark(s.row, c)">备注</el-button>
								</div>
								<!-- 展开区会话太多(如749个), 每个分组独立翻页, 与外层人员列表分页互不干扰 -->
								<el-pagination v-if="g.total > histPageSize" :key="g.k + 'p'" class="tsd-hist-pager" small
									layout="total, prev, pager, next" :current-page="g.page" :page-size="histPageSize" :total="g.total"
									@current-change="(p) => onHistPage(s.row.uid, g.k, p)"></el-pagination>
							</template>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="用户" min-width="130" show-overflow-tooltip>
					<template slot-scope="s">
						<el-tag v-if="isAdminParty(s.row.uid, s.row.name)" size="mini" type="danger" style="margin-right:4px">管理员</el-tag>
						<span :class="isAdminParty(s.row.uid, s.row.name) ? 'ts-admin' : ''">{{ s.row.name }}</span>
					</template>
				</el-table-column>
				<el-table-column label="地区" min-width="86" show-overflow-tooltip>
					<template slot-scope="s">{{ s.row.region || '-' }}</template>
				</el-table-column>
				<el-table-column label="聊天对象" width="66">
					<template slot-scope="s">{{ s.row.partners }}人</template>
				</el-table-column>
				<el-table-column label="未读" width="48">
					<template slot-scope="s">
						<span :class="s.row.unread ? 'tsd-unread-badge' : 'tsd-nocall'">{{ s.row.unread || 0 }}</span>
					</template>
				</el-table-column>
				<el-table-column label="收藏" width="48">
					<template slot-scope="s">
						<span :class="s.row.fav ? 'tsd-fav-badge' : 'tsd-nocall'">{{ s.row.fav || 0 }}</span>
					</template>
				</el-table-column>
				<el-table-column label="含电话消息" width="86">
					<template slot-scope="s">{{ s.row.cnt }}条</template>
				</el-table-column>
				<el-table-column label="最近时间" width="96">
					<template slot-scope="s">{{ fmtTime(s.row.lastTime) }}</template>
				</el-table-column>
				<el-table-column label="操作" width="88">
					<template slot-scope="s">
						<el-button type="text" size="mini" :class="isAdminParty(s.row.uid, s.row.name) ? 'ts-admin' : ''" @click="toggleAdminUser(s.row.uid, s.row.name)">{{ isAdminParty(s.row.uid, s.row.name) ? '取消管理员' : '标记管理员' }}</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 收藏/已读视图: 单条会话维度, 可直接看记录/改备注/取消收藏; 客户端分页 -->
			<el-table v-else :data="convPagedRows" size="small" max-height="calc(100vh - 230px)" :empty-text="phoneEmptyText">
				<el-table-column label="会话" min-width="170" show-overflow-tooltip>
					<template slot-scope="s">
						<el-tag size="mini" :type="s.row.read ? 'info' : 'danger'" style="margin-right:6px">{{ s.row.read ? '已读' : '未读' }}</el-tag>
						<span :class="isAdminParty(s.row.a, s.row.aName || s.row.a) ? 'ts-admin' : ''">{{ s.row.aName || s.row.a }}</span> ⇄ <span :class="isAdminParty(s.row.b, s.row.bName || s.row.b) ? 'ts-admin' : ''">{{ s.row.bName || s.row.b }}</span>
					</template>
				</el-table-column>
				<el-table-column label="含电话" width="70">
					<template slot-scope="s">{{ s.row.cnt }}条</template>
				</el-table-column>
				<el-table-column label="地区" min-width="92" show-overflow-tooltip>
					<template slot-scope="s">{{ s.row.aRegion || '-' }} / {{ s.row.bRegion || '-' }}</template>
				</el-table-column>
				<el-table-column label="最近" width="90">
					<template slot-scope="s">{{ fmtTime(s.row.lastTime) }}</template>
				</el-table-column>
				<el-table-column label="备注" min-width="96" show-overflow-tooltip>
					<template slot-scope="s">
						<span class="tsd-remark-text" style="max-width:none">{{ s.row.remark || '-' }}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="196">
					<template slot-scope="s">
						<el-button type="text" size="mini" @click="openPhoneMsgs({ name: s.row.aName, unread: 0 }, s.row)">查看记录</el-button>
						<el-button type="text" size="mini" @click="editPhoneRemark(s.row, s.row)">备注</el-button>
						<el-button v-if="phoneFilter === 'fav'" type="text" size="mini" class="tsd-danger" @click="togglePhoneFav(s.row, s.row)">取消收藏</el-button>
						<el-button v-if="phoneFilter === 'read'" type="text" size="mini" class="tsd-danger" @click="toggleRead(null, s.row)">取消已读</el-button>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination v-if="(phoneFilter === 'all' || phoneFilter === 'unread') && phoneTotal > 0" class="tsp-pager"
				layout="total, prev, pager, next" :current-page="phonePage" :page-size="phonePageSize" :total="phoneTotal"
				@current-change="onPhonePage"></el-pagination>
			<el-pagination v-if="(phoneFilter === 'read' || phoneFilter === 'fav') && phoneTotal > 0" class="tsp-pager"
				layout="total, prev, pager, next" :current-page="convPage" :page-size="convPageSize" :total="phoneTotal"
				@current-change="onConvPage"></el-pagination>
		</div>

		<!-- 聊天记录弹窗(默认完整历史便于分析, 可切只看含电话) -->
		<el-dialog title="聊天记录" :visible.sync="phoneMsgDlg.visible" width="680px" append-to-body :close-on-click-modal="false">
			<div class="tsd-call-head">
				<span class="tsd-call-party" :class="isAdminParty(phoneMsgDlg.a, phoneMsgDlg.aName) ? 'ts-admin' : ''"
					:title="isAdminParty(phoneMsgDlg.a, phoneMsgDlg.aName) ? '管理员(点击取消标记)' : '点击标记为管理员'"
					@click="toggleAdminUser(phoneMsgDlg.a, phoneMsgDlg.aName)">
					<el-tag v-if="isAdminParty(phoneMsgDlg.a, phoneMsgDlg.aName)" size="mini" type="danger" style="margin-right:4px">管理员</el-tag>{{ phoneMsgDlg.aName }}
				</span>
				<span class="tsd-call-arrow">⇄</span>
				<span class="tsd-call-party" :class="isAdminParty(phoneMsgDlg.b, phoneMsgDlg.bName) ? 'ts-admin' : ''"
					:title="isAdminParty(phoneMsgDlg.b, phoneMsgDlg.bName) ? '管理员(点击取消标记)' : '点击标记为管理员'"
					@click="toggleAdminUser(phoneMsgDlg.b, phoneMsgDlg.bName)">
					<el-tag v-if="isAdminParty(phoneMsgDlg.b, phoneMsgDlg.bName)" size="mini" type="danger" style="margin-right:4px">管理员</el-tag>{{ phoneMsgDlg.bName }}
				</span>
				<el-switch v-model="phoneMsgDlg.onlyPhone" active-text="只看含电话" style="margin-left:auto" @change="reloadPhoneMsgs()"></el-switch>
			</div>
			<el-table :data="phoneMsgDlg.list" size="small" v-loading="phoneMsgDlg.loading" max-height="400" empty-text="暂无记录">
				<el-table-column label="时间" width="110">
					<template slot-scope="s">{{ fmtTime(s.row.time) }}</template>
				</el-table-column>
				<el-table-column label="发送人" width="160" show-overflow-tooltip>
									<template slot-scope="s"><span :class="isAdminLabel(s.row.senderName) ? 'ts-admin' : ''">{{ s.row.senderName }}</span></template>
								</el-table-column>
				<el-table-column :label="phoneMsgDlg.onlyPhone ? '消息内容(含电话)' : '消息内容'" min-width="260">
					<template slot-scope="s">
						<template v-for="(seg, si) in parseMsgSegs(s.row.content)">
							<img v-if="seg.img" :key="'i' + si" :src="seg.url"
								class="tsd-msg-img" @click="imgViewer.url = seg.url; imgViewer.visible = true">
							<a v-else-if="seg.url" :key="'l' + si" :href="seg.url" target="_blank" rel="noopener" class="tsd-msg-link">{{ seg.url }}</a>
							<span v-else-if="seg.phone" :key="'p' + si" class="tsd-phone" :class="isAdminPhone(seg.phone) || isAdminLabel(s.row.senderName) ? 'ts-admin' : ''"
								:title="isAdminPhone(seg.phone) ? '管理员号码(点击取消标记)' : '点击标记为管理员号码'" @click="toggleAdminPhone(seg.phone)">{{ seg.phone }}</span>
							<span v-else :key="'t' + si" class="tsd-hist-content">{{ seg.text }}</span>
						</template>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="80">
					<template slot-scope="s">
						<el-button v-if="msgFavId(s.row)" type="text" size="mini" class="tsd-fav-badge" @click="msgFavCancelMsg(s.row)">★已收藏</el-button>
						<el-button v-else type="text" size="mini" @click="msgFavAdd(s.row)">☆收藏</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="tsp-tip"><i class="el-icon-info"></i><span>按时间正序展示,最多最近1000条；图片点击可放大查看。</span></div>
		</el-dialog>

		<!-- 管理员标记管理(全局共享: 按人/按号码) -->
		<el-dialog title="管理员标记(全局共享)" :visible.sync="adminDlg.visible" width="560px" append-to-body :close-on-click-modal="false">
			<div class="ts-admin-add">
				<el-input v-model="adminDlg.phone" size="mini" placeholder="输入完整手机号标记为管理员号码" style="width:240px"></el-input>
				<el-button size="mini" type="primary" @click="addAdminPhone()">添加</el-button>
			</div>
			<el-table :data="admins" size="small" max-height="320" empty-text="还没有管理员标记">
				<el-table-column label="对象" min-width="200">
					<template slot-scope="s">
						<span v-if="s.row.name">{{ s.row.name }}</span>
						<span class="ts-admin">{{ s.row.phone || ('UID:' + s.row.legacyUserId) }}</span>
					</template>
				</el-table-column>
				<el-table-column label="标记时间" width="100">
					<template slot-scope="s">{{ fmtTime(s.row.createdTime) }}</template>
				</el-table-column>
				<el-table-column label="操作" width="90">
					<template slot-scope="s">
						<el-button type="text" size="mini" class="tsd-danger" @click="removeAdmin(s.row)">取消标记</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="tsp-tip"><i class="el-icon-info"></i><span>标记后该用户/号码在会销各列表与聊天记录中以红色高亮; 聊天记录里点号码也可快速标记/取消。</span></div>
		</el-dialog>

		<!-- 消息收藏夹(当前用户收藏的单条消息; 列表只展示消息本身, 支持勾选批量导出) -->
		<el-dialog title="消息收藏夹" :visible.sync="msgFavDlg.visible" width="760px" append-to-body :close-on-click-modal="false">
			<div class="ts-fav-bar">
				<el-radio-group v-model="msgFavDlg.filter" size="mini">
					<el-radio-button label="all">全部({{ msgFavDlg.list.length }})</el-radio-button>
					<el-radio-button label="unexported">未导出({{ unexportedFavCount }})</el-radio-button>
					<el-radio-button label="exported">已导出({{ msgFavDlg.list.length - unexportedFavCount }})</el-radio-button>
				</el-radio-group>
				<el-button size="mini" type="primary" :disabled="!msgFavDlg.selection.length" @click="exportFavs(msgFavDlg.selection)">导出所选({{ msgFavDlg.selection.length }})</el-button>
				<el-button size="mini" :disabled="!unexportedFavCount" @click="exportFavs(unexportedFavRows)">导出未导出({{ unexportedFavCount }})</el-button>
				<span class="tsd-nocall">导出为xlsx表格, 国内WPS/Excel双击直接打开; 导出后自动打"已导出"标记防重复</span>
			</div>
			<el-table :data="favRows" size="small" v-loading="msgFavDlg.loading" max-height="420" empty-text="还没有收藏的消息" @selection-change="onFavSelChange">
				<el-table-column type="selection" width="45"></el-table-column>
				<el-table-column label="收藏的消息" min-width="420">
					<template slot-scope="s">
						<el-tag v-if="s.row.exported" size="mini" type="success" style="margin-right:6px">已导出</el-tag><span class="tsd-fav-content">{{ s.row.content }}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="140">
					<template slot-scope="s">
						<el-button type="text" size="mini" @click="openFavConv(s.row)">查看会话</el-button>
						<el-button type="text" size="mini" class="tsd-danger" @click="msgFavDel(s.row)">取消收藏</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="tsp-tip"><i class="el-icon-info"></i><span>列表只展示收藏的消息本身; 切"未导出"可只看待导出的, 导出后自动进"已导出"; 点"查看会话"可打开它所在的完整聊天记录。</span></div>
		</el-dialog>

		<!-- 图片查看器(append-to-body挂到body层; 点遮罩或右上角✕关闭) -->
		<el-dialog :visible.sync="imgViewer.visible" append-to-body fullscreen custom-class="tsd-img-dialog">
			<img :src="imgViewer.url" class="tsd-img-full">
		</el-dialog>
	</div>
</template>

<script>
import bizApi from "../api/bizApi.js";
import * as XLSX from "xlsx";

export default {
	name: "telesales",
	data() {
		return {
			loading: false,
			rows: [],
			phoneExpandLoadingId: null,
			phoneHistCache: {}, // uid -> 该人的含电话私聊会话(展开行按需加载)
			phoneFilter: 'all', // all全部 unread未读 fav收藏
			phoneRefreshing: false,
			phonePage: 1,
			phonePageSize: 20,
			phoneTotal: 0,
			convPage: 1, // 已读/收藏列表客户端分页页码
			convPageSize: 20,
			histPage: {}, // 展开区每个人员的分组页码 { uid: { unread, read } }
			histPageSize: 20,
			phoneMsgDlg: { visible: false, loading: false, list: [], title: '', a: null, b: null, aName: '', bName: '', onlyPhone: false, favMap: {} },
			imgViewer: { visible: false, url: '' },
			admins: [], // 全局管理员标记(按人/按号码)
			adminDlg: { visible: false, phone: '' },
			msgFavDlg: { visible: false, loading: false, list: [], selection: [], filter: 'all' }
		};
	},
	computed: {
		// 收藏夹按导出状态筛选: 未导出/已导出分开看, 避免重复导出
		favRows() {
			if (this.msgFavDlg.filter === 'exported') return this.msgFavDlg.list.filter((r) => r.exported);
			if (this.msgFavDlg.filter === 'unexported') return this.msgFavDlg.list.filter((r) => !r.exported);
			return this.msgFavDlg.list;
		},
		unexportedFavRows() {
			return this.msgFavDlg.list.filter((r) => !r.exported);
		},
		unexportedFavCount() {
			return this.unexportedFavRows.length;
		},
		// 已读/收藏列表一次性返回全量, 前端切片分页
		convPagedRows() {
			const from = (this.convPage - 1) * this.convPageSize;
			return this.rows.slice(from, from + this.convPageSize);
		},
		phoneEmptyText() {
			if (this.phoneFilter === 'unread') return '没有未读的会话，都看完啦';
			if (this.phoneFilter === 'read') return '还没有已读会话，在展开列表里点"标记已读"或查看过记录后会进入这里';
			if (this.phoneFilter === 'fav') return '还没有收藏的会话';
			return '暂无含电话的私聊用户';
		}
	},
	mounted() {
		this.load();
		this.loadAdmins();
	},
	methods: {
		load() {
			this.loading = true;
			this.phoneHistCache = {};
			if (this.phoneFilter === 'fav' || this.phoneFilter === 'read') {
				// 收藏/已查看列表: 单条会话维度, 不分页
				const req = this.phoneFilter === 'fav' ? bizApi.legacyPhoneFavs() : bizApi.legacyPhoneReads();
				req.then((list) => {
					this.rows = list || [];
					this.phoneTotal = this.rows.length;
					this.convPage = 1;
				}).catch((e) => {
					this.$message.error(e.message || '加载失败');
				}).finally(() => {
					this.loading = false;
				});
				return;
			}
			bizApi.legacyPhoneUsers(this.phonePage, this.phonePageSize, this.phoneFilter).then((res) => {
				this.rows = (res && res.list) || [];
				this.phoneTotal = (res && res.total) || 0;
			}).catch((e) => {
				this.$message.error(e.message || '加载失败');
			}).finally(() => {
				this.loading = false;
			});
		},
		onPhonePage(p) {
			this.phonePage = p;
			this.load();
		},
		onConvPage(p) {
			this.convPage = p;
		},
		onPhoneFilter() {
			this.phonePage = 1;
			this.load();
		},
		onPhoneRefresh() {
			this.phoneRefreshing = true;
			bizApi.legacyPhoneRefresh().then((res) => {
				this.$message.success('已刷新老库数据(含电话会话' + ((res && res.convs) || 0) + '个)');
				this.phonePage = 1;
				this.load();
			}).catch((e) => {
				this.$message.error(e.message || '刷新失败');
			}).finally(() => {
				this.phoneRefreshing = false;
			});
		},
		onPhoneExpand(row, expandedRows) {
			const expanded = expandedRows.some((r) => r.uid === row.uid);
			if (!expanded) {
				return;
			}
			// 每次展开都重拉: 已读/收藏标记全账号共享, 不用旧缓存, 保证其他账号的标记毫秒级可见
			this.phoneExpandLoadingId = row.uid;
			bizApi.legacyPhoneConvs(row.uid).then((list) => {
				this.$set(this.phoneHistCache, row.uid, list || []);
				this.$set(this.histPage, row.uid, { unread: 1, read: 1 });
			}).catch((e) => {
				this.$message.error(e.message || '加载会话失败');
			}).finally(() => {
				this.phoneExpandLoadingId = null;
			});
		},
		// 展开行已读/未读分组: 未读tab只给未读组; 其余tab未读在前、已读在后分开展示不混排;
		// 每组客户端切片分页(会话可达数百条, 全渲染会卡死), 页码记在 histPage[uid]
		convGroups(uid) {
			const list = this.phoneHistCache[uid] || [];
			const unreadAll = list.filter((c) => !c.read);
			const readAll = list.filter((c) => c.read);
			const pg = this.histPage[uid] || { unread: 1, read: 1 };
			const size = this.histPageSize;
			const build = (k, title, all) => {
				const page = Math.min(pg[k] || 1, Math.max(1, Math.ceil(all.length / size)));
				return { k, title, total: all.length, page, list: all.slice((page - 1) * size, page * size) };
			};
			if (this.phoneFilter === 'unread') {
				return unreadAll.length ? [build('unread', '未读会话', unreadAll)] : [];
			}
			return [unreadAll.length ? build('unread', '未读会话', unreadAll) : null,
				readAll.length ? build('read', '已读会话', readAll) : null].filter((g) => g);
		},
		onHistPage(uid, k, p) {
			if (!this.histPage[uid]) {
				this.$set(this.histPage, uid, { unread: 1, read: 1 });
			}
			this.histPage[uid][k] = p;
		},
		markPhoneConv(conv, data) {
			bizApi.legacyPhoneMark(conv.a, conv.b, data).catch((e) => {
				this.$message.error(e.message || '标记失败');
			});
		},
		togglePhoneFav(row, conv) {
			conv.fav = !conv.fav;
			if (this.phoneFilter === 'fav') {
				if (!conv.fav) {
					this.rows = this.rows.filter((r) => r !== conv);
					this.phoneTotal = this.rows.length;
					this.fixConvPage();
				}
			} else {
				row.fav = Math.max(0, (row.fav || 0) + (conv.fav ? 1 : -1));
			}
			this.markPhoneConv(conv, { fav: conv.fav ? 1 : 0 });
		},
		editPhoneRemark(row, conv) {
			this.$prompt('给该会话写备注(方便后续跟进)', '备注', {
				confirmButtonText: '保存', cancelButtonText: '取消',
				inputValue: conv.remark || '', inputPlaceholder: '例如: 客户意向高,下周跟进',
				inputValidator: (v) => !v || v.length <= 500 || '备注不能超过500字'
			}).then(({ value }) => {
				conv.remark = (value || '').trim();
				this.markPhoneConv(conv, { remark: conv.remark });
			}).catch(() => { });
		},
		loadAdmins() {
			bizApi.legacyAdmins().then((list) => {
				this.admins = list || [];
			}).catch(() => { });
		},
		isAdminUser(uid) {
			return uid != null && this.admins.some((a) => a.legacyUserId != null && String(a.legacyUserId) === String(uid));
		},
		isAdminPhone(p) {
			return !!p && this.admins.some((a) => a.phone && a.phone === p);
		},
		// 掩码展示(如 184****6872)与管理员完整号码的前3后4匹配, 保证所有对话里掩码展示也标红
		isAdminLabel(label) {
			const s = label == null ? '' : String(label);
			if (!s || !this.admins.length) return false;
			return this.admins.some((a) => {
				if (a.phone && s.indexOf(a.phone) >= 0) return true;
				const m = s.match(/(\d{3})\*+(\d{4})/);
				if (m && a.phone && a.phone.indexOf(m[1]) === 0 && a.phone.slice(-4) === m[2]) return true;
				return false;
			});
		},
		isAdminParty(id, label) {
			return this.isAdminUser(id) || this.isAdminLabel(label);
		},
		toggleAdminUser(uid, name) {
			const on = !this.isAdminParty(uid, name);
			this.$confirm(on ? '将该用户标记为管理员? 其所有会话将红色高亮' : '取消该用户的管理员标记?', '管理员标记', {
				confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
			}).then(() => {
				return bizApi.legacyAdminMark({ legacyUserId: uid, name: name || null, on: on ? 1 : 0 });
			}).then(() => {
				this.$message.success(on ? '已标记为管理员' : '已取消管理员标记');
				this.loadAdmins();
			}).catch((e) => {
				if (e && e.message) this.$message.error(e.message);
			});
		},
		toggleAdminPhone(phone) {
			const on = !this.isAdminPhone(phone);
			this.$confirm(on ? ('将号码 ' + phone + ' 标记为管理员号码? 聊天记录中该号码将红色高亮') : ('取消管理员号码 ' + phone + ' 的标记?'), '管理员号码', {
				confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
			}).then(() => {
				return bizApi.legacyAdminMark({ phone, on: on ? 1 : 0 });
			}).then(() => {
				this.$message.success(on ? '已标记为管理员号码' : '已取消管理员号码标记');
				this.loadAdmins();
			}).catch((e) => {
				if (e && e.message) this.$message.error(e.message);
			});
		},
		addAdminPhone() {
			const p = (this.adminDlg.phone || '').trim();
			if (!/^1\d{10}$/.test(p)) {
				this.$message.warning('请输入正确的11位手机号');
				return;
			}
			bizApi.legacyAdminMark({ phone: p, on: 1 }).then(() => {
				this.$message.success('已标记为管理员号码');
				this.adminDlg.phone = '';
				this.loadAdmins();
			}).catch((e) => {
				this.$message.error(e.message || '标记失败');
			});
		},
		removeAdmin(row) {
			const data = row.legacyUserId != null ? { legacyUserId: row.legacyUserId, on: 0 } : { phone: row.phone, on: 0 };
			bizApi.legacyAdminMark(data).then(() => {
				this.$message.success('已取消标记');
				this.loadAdmins();
			}).catch((e) => {
				this.$message.error(e.message || '操作失败');
			});
		},
		toggleRead(row, conv) {
			conv.read = !conv.read;
			if (row && row.unread != null) {
				row.unread = Math.max(0, row.unread + (conv.read ? -1 : 1));
			}
			this.markPhoneConv(conv, { read: conv.read ? 1 : 0 });
			if (this.phoneFilter === 'read' && !conv.read) {
				this.rows = this.rows.filter((r) => r !== conv);
				this.phoneTotal = this.rows.length;
				this.fixConvPage();
			}
			if (conv.read) {
				this.dropReadRow(row);
			}
		},
		// 未读tab: 某人标完已读后已无未读会话, 从列表移除该行(避免已读了还显示在未读列表);
		// 当前页移空则回退一页重拉
		dropReadRow(row) {
			if (this.phoneFilter !== 'unread' || !row || row.unread !== 0) {
				return;
			}
			const idx = this.rows.indexOf(row);
			if (idx < 0) {
				return;
			}
			this.rows.splice(idx, 1);
			this.phoneTotal = Math.max(0, this.phoneTotal - 1);
			if (!this.rows.length && this.phoneTotal > 0) {
				this.phonePage = Math.max(1, this.phonePage - 1);
				this.load();
			}
		},
		// 删除行后当前页空了则回退一页, 避免停在空白页
		fixConvPage() {
			if (this.convPage > 1 && !this.convPagedRows.length) {
				this.convPage = Math.max(1, this.convPage - 1);
			}
		},
		msgFavOpen() {
			this.msgFavDlg.visible = true;
			this.msgFavDlg.loading = true;
			this.msgFavDlg.selection = [];
			bizApi.legacyMsgFavs().then((list) => {
				this.msgFavDlg.list = list || [];
			}).catch((e) => {
				this.$message.error(e.message || '加载失败');
			}).finally(() => {
				this.msgFavDlg.loading = false;
			});
		},
		onFavSelChange(sel) {
			this.msgFavDlg.selection = sel || [];
		},
		// 批量导出收藏消息: 只导出消息本身, 生成原生xlsx(SheetJS), 国内WPS/Excel双击直接打开不乱码
		exportFavs(rows) {
			if (!rows || !rows.length) {
				this.$message.warning('没有可导出的收藏消息');
				return;
			}
			const aoa = [['收藏的消息']].concat(rows.map((r) => [r.content == null ? '' : String(r.content)]));
			const ws = XLSX.utils.aoa_to_sheet(aoa);
			ws['!cols'] = [{ wch: 80 }];
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, '消息收藏');
			const d = new Date();
			const p = (n) => (n < 10 ? '0' + n : n);
			XLSX.writeFile(wb, '消息收藏导出_' + d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + '_' + p(d.getHours()) + p(d.getMinutes()) + '.xlsx');
			// 落库"已导出"标记: 下次切"未导出"不再出现, 避免重复导出
			const ids = rows.map((r) => r.id);
			const now = Date.now();
			bizApi.legacyMsgFavExported(ids).then(() => {
				this.msgFavDlg.list.forEach((r) => {
					if (ids.indexOf(r.id) >= 0) {
						r.exported = 1;
						r.exportTime = now;
					}
				});
				this.msgFavDlg.selection = [];
			}).catch((e) => {
				this.$message.error('文件已导出, 但已导出标记失败: ' + (e.message || ''));
			});
			this.$message.success('已导出' + rows.length + '条收藏消息');
		},
		msgFavAdd(msg) {
			bizApi.legacyMsgFav({
				a: this.phoneMsgDlg.a, b: this.phoneMsgDlg.b, time: msg.time,
				senderName: msg.senderName, content: msg.content
			}).then((id) => {
				this.$set(this.phoneMsgDlg.favMap, this.msgFavKey(msg), id);
				this.$message.success('已收藏到消息收藏夹');
			}).catch((e) => {
				this.$message.error(e.message || '收藏失败');
			});
		},
		// 聊天记录里点"★已收藏"取消收藏
		msgFavCancelMsg(msg) {
			const key = this.msgFavKey(msg);
			const id = this.phoneMsgDlg.favMap[key];
			if (!id) return;
			bizApi.legacyMsgFavDel(id).then(() => {
				this.$delete(this.phoneMsgDlg.favMap, key);
				this.$message.success('已取消收藏');
			}).catch((e) => {
				this.$message.error(e.message || '操作失败');
			});
		},
		msgFavDel(row) {
			bizApi.legacyMsgFavDel(row.id).then(() => {
				this.msgFavDlg.list = this.msgFavDlg.list.filter((r) => r.id !== row.id);
				this.msgFavDlg.selection = this.msgFavDlg.selection.filter((r) => r.id !== row.id);
			}).catch((e) => {
				this.$message.error(e.message || '操作失败');
			});
		},
		// 从收藏夹直接打开该消息所在的完整会话
		openFavConv(r) {
			this.openPhoneMsgs({ name: r.aName, unread: 0 }, r);
		},
		openPhoneMsgs(row, conv) {
			// 查看记录即视为已读, 同步减该人的未读数
			if (!conv.read) {
				conv.read = true;
				if (row.unread > 0) {
					row.unread--;
				}
				this.markPhoneConv(conv, { read: 1 });
				this.dropReadRow(row);
			}
			this.phoneMsgDlg.visible = true;
			this.phoneMsgDlg.title = (row.name || row.uid) + ' ⇄ ' + (conv.bName || conv.b);
			this.phoneMsgDlg.a = conv.a;
			this.phoneMsgDlg.b = conv.b;
			this.phoneMsgDlg.aName = row.name || conv.aName || conv.a;
			this.phoneMsgDlg.bName = conv.bName || conv.b;
			this.phoneMsgDlg.onlyPhone = false;
			this.phoneMsgDlg.favMap = {};
			this.loadMsgFavMap();
			this.reloadPhoneMsgs();
		},
		// 拉当前用户收藏夹建 msgTime→收藏id 映射, 聊天记录里回显"已收藏"
		loadMsgFavMap() {
			bizApi.legacyMsgFavs().then((list) => {
				const m = {};
				(list || []).forEach((r) => {
					const mn = Math.min(r.a, r.b);
					const mx = Math.max(r.a, r.b);
					m[mn + '_' + mx + '_' + r.msgTime] = r.id;
				});
				this.phoneMsgDlg.favMap = m;
			}).catch(() => {});
		},
		msgFavKey(msg) {
			const a = this.phoneMsgDlg.a;
			const b = this.phoneMsgDlg.b;
			return Math.min(a, b) + '_' + Math.max(a, b) + '_' + msg.time;
		},
		msgFavId(msg) {
			return this.phoneMsgDlg.favMap[this.msgFavKey(msg)] || null;
		},
		reloadPhoneMsgs() {
			this.phoneMsgDlg.loading = true;
			this.phoneMsgDlg.list = [];
			bizApi.legacyPhoneMsgs(this.phoneMsgDlg.a, this.phoneMsgDlg.b, this.phoneMsgDlg.onlyPhone).then((list) => {
				this.phoneMsgDlg.list = list || [];
			}).catch((e) => {
				this.$message.error(e.message || '加载失败');
			}).finally(() => {
				this.phoneMsgDlg.loading = false;
			});
		},
		fmtTime(t) {
			if (!t) return '-';
			const d = new Date(t);
			const p = (n) => (n < 10 ? '0' + n : n);
			return `${d.getMonth() + 1}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
		},
		parseMsgSegs(content) {
			// 把消息内容拆成 文本/图片/链接/手机号 片段(手机号可点击标记管理员)
			if (!content) return [];
			const segs = [];
			const pushText = (str) => {
				const pre = /(1[3-9]\d{9})/g;
				let l = 0;
				let pm;
				while ((pm = pre.exec(str)) !== null) {
					if (pm.index > l) {
						segs.push({ text: str.slice(l, pm.index) });
					}
					segs.push({ phone: pm[1] });
					l = pm.index + pm[1].length;
				}
				if (l < str.length) {
					segs.push({ text: str.slice(l) });
				}
			};
			const re = /https?:\/\/[^\s一-龥，。！？、；："“”]+/g;
			let last = 0;
			let m;
			while ((m = re.exec(content)) !== null) {
				if (m.index > last) {
					pushText(content.slice(last, m.index));
				}
				const url = m[0];
				const isImg = /\.(jpg|jpeg|png|gif|webp)([?#].*)?$/i.test(url);
				segs.push({ url, img: isImg });
				last = m.index + url.length;
			}
			if (last < content.length) {
				pushText(content.slice(last));
			}
			return segs;
		}
	}
};
</script>

<style lang="scss" scoped>
.tsp-page {
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100vh;
	overflow: hidden;
	box-sizing: border-box;
	padding: 16px 20px 12px;
	background: #f5f7fa;
}
.tsp-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
	gap: 8px 10px;
	margin-bottom: 12px;
}
.tsp-title {
	font-size: 20px;
	font-weight: 700;
	color: #303133;
}
.tsp-bar {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 10px;
}
.tsp-body {
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	background: #fff;
	border-radius: 8px;
	padding: 12px 14px;
	box-shadow: 0 1px 4px rgba(0, 0, 0, .06);
	/* 内容超出时允许纵向滚动, 保证分页器永远可达(外层页面是 overflow:hidden);
	   横向禁止: 列宽已自适应屏幕, 表格超宽时由 el-table 内部自己横向滚动 */
	overflow-y: auto;
	overflow-x: hidden;
}
.tsp-pager {
	flex-shrink: 0;
	margin-top: 12px;
	text-align: right;
}
.tsp-tip {
	display: flex;
	align-items: center;
	gap: 6px;
	margin-top: 8px;
	color: #555;
	font-size: 12px;
	i { color: #1677ff; }
}
/* 以下为电话会话表格/子弹窗复用的样式(与聊天内嵌弹窗保持一致) */
.tsd-expand { padding: 6px 12px 6px 40px; min-height: 28px; }
.tsd-group-head {
	padding: 6px 0 2px;
	font-size: 12px;
	font-weight: 600;
	&:not(:first-child) { margin-top: 4px; border-top: 1px solid #f0f0f0; }
}
.tsd-read-badge { color: #909399; }
.tsd-hist-pager { padding: 4px 0 10px; text-align: right; }
.tsd-hist-line {
	display: flex;
	align-items: baseline;
	flex-wrap: wrap;
	gap: 2px 10px;
	padding: 4px 0;
	font-size: 12px;
	border-bottom: 1px dashed #eee;
	&:last-child { border-bottom: none; }
}
.tsd-hist-time { color: #999; flex-shrink: 0; }
.tsd-hist-caller { color: #1677ff; flex-shrink: 0; }
.tsd-hist-content { color: #555; word-break: break-all; }
.tsd-hist-region { color: #67c23a; font-size: 12px; margin-left: 2px; }
.tsd-nocall { color: #999; }
.tsd-unread-badge { color: #f56c6c; font-weight: bold; }
.tsd-fav-badge { color: #e6a23c; font-weight: bold; }
.tsd-remark-text { color: #e6a23c; max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.tsd-danger { color: #f56c6c; }
.ts-admin { color: #f56c6c; font-weight: bold; }
.tsd-call-party { cursor: pointer; }
.tsd-call-arrow { color: #999; margin: 0 2px; }
.tsd-phone { color: #1677ff; cursor: pointer; word-break: break-all; &:hover { text-decoration: underline; } }
/* 管理员发的消息里电话号码红色: 双类名提高优先级盖过 .tsd-phone 的蓝色 */
.tsd-phone.ts-admin { color: #f56c6c; }
.ts-admin-add { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; }
.ts-fav-bar {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
	margin-bottom: 10px;
}
.tsd-fav-content {
	white-space: pre-wrap;
	word-break: break-all;
	color: #303133;
	line-height: 1.6;
}
.tsd-call-head {
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 12px;
	font-size: 14px;
}
.tsd-msg-img {
	max-width: 110px;
	max-height: 110px;
	margin: 2px 6px 2px 0;
	border-radius: 4px;
	cursor: pointer;
	vertical-align: middle;
	&:hover { opacity: .85; }
}
.tsd-msg-link { color: #1677ff; word-break: break-all; }
</style>

<!-- 图片查看器样式: 必须非scoped——append-to-body弹窗挂在body下, 节点不带本组件scoped标记 -->
<style lang="scss">
/* 弹窗宽度自适应小屏幕: 不超过视口, 避免横向滚动 */
.el-dialog {
	max-width: 96vw;
}
.tsd-img-dialog {
	background: transparent !important;
	box-shadow: none;
	margin: 0 !important;
	display: flex;
	flex-direction: column;
	.el-dialog__header {
		padding: 14px 18px 0;
		position: relative;
		z-index: 1;
	}
	.el-dialog__headerbtn .el-dialog__close {
		color: #fff;
		font-size: 30px;
		&:hover { color: #f56c6c; }
	}
	.el-dialog__body {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0;
		overflow: auto;
	}
}
.tsd-img-full {
	max-width: 90vw;
	max-height: 88vh;
	width: auto;
	height: auto;
	box-shadow: 0 4px 30px rgba(0, 0, 0, .6);
}
</style>
